import {t} from "../../../../../../services/i18n";
import FoldableSettingSection from "../../../../../common/FoldableSettingSection";
import PersonalDetails from "./PersonalDetails";
import CustomSwitch from "../../../../../common/CustomSwitch";
import React, {useEffect, useState} from "react";
import {HStack, VStack} from "native-base";
import AppText from "../../../../../common/AppText";
import InfoTooltip from "../../../../../common/InfoTooltip";
import {Colors} from "../../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {isMobile} from "../../../../../../services/Helpers";

const GroupDetails = (props) => {
    const {errors, touched, setFieldValue, setTouched, values, validationSchema} = props
    const [headDetailsIsOpen, setHeadDetailsIsOpen] = useState(true)
    const [childDetailsIsOpen, setChildDetailsIsOpen] = useState(false)

    useEffect(() => {
        setTouched({})
    }, [])

    const parentCond = validationSchema?.fields?.parent;
    const parentSchema = parentCond?.resolve
        ? parentCond.resolve({ parent: values, value: values.parent, context: values })
        : parentCond;

    const handleChildChange = (field) => (value) => {
        setFieldValue(`child.${field}`, value)
    }

    const handleParentChange = (field) => (value) => {
        setFieldValue(`parent.${field}`, value)
    }


    return (
        <VStack space={'1rem'}>
            <HStack alignItems={'center'}>
                <HStack space={'0.5rem'} alignItems={'center'}>
                    <CustomSwitch isChecked={values.isChildRegistration} onToggle={(val) => setFieldValue('isChildRegistration', val)} />
                    <AppText>{t(values.isChildRegistration ? 'with-head' : 'without-head')}</AppText>
                </HStack>
                <InfoTooltip title={t('toggle-head-info')}/>
            </HStack>
            {values.isChildRegistration ?
                <>
                    {<FoldableSettingSection header={isMobile ?  t(`group-head`) : t(`group-head`) + ' - ' + values.parent.first_name + ' ' + values.parent.last_name} isOpen={headDetailsIsOpen}
                                             onToggle={() => setHeadDetailsIsOpen(!headDetailsIsOpen)}
                                             errorIcon={errors.parent && touched.parent}

                    >
                        <PersonalDetails values={values.parent} errors={errors.parent || {}} touched={touched.parent || {}}
                                         validationSchema={parentSchema}
                                         setFieldValue={(field, value) => setFieldValue(`parent.${field}`, value)}
                                         handleChange={handleParentChange}/>
                    </FoldableSettingSection>}
                    <FoldableSettingSection
                        header={isMobile ?  t(`group-child`) : t(`group-child`) + ' - ' + values.child.first_name + ' ' + values.child.last_name}
                        isOpen={childDetailsIsOpen}
                        onToggle={() => setChildDetailsIsOpen(!childDetailsIsOpen)}
                        errorIcon={errors.child && touched.child}
                    >
                        <PersonalDetails values={values.child} errors={errors.child || {}} touched={touched.child || {}} validationSchema={validationSchema?.fields.child} setFieldValue={(field, value) => setFieldValue(`child.${field}`, value)} handleChange={handleChildChange} isChild={true}/>
                    </FoldableSettingSection>
                </> :
                <VStack p={'1rem'} space={'0.5rem'} borderWidth={1} borderColor={Colors.borderColor} borderRadius={4} opacity={1}>
                    <HStack alignItems={'center'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} boldFont>{t(`group-child-without-head`)}</AppText>
                        <InfoTooltip title={t('group-child-tooltip-without-head')}/>
                    </HStack>
                    <PersonalDetails values={values.child} errors={errors.child || {}} touched={touched.child || {}} validationSchema={validationSchema?.fields.child} setFieldValue={(field, value) => setFieldValue(`child.${field}`, value)} handleChange={handleChildChange} isChild={true}/>
                </VStack>

                }
        </VStack>

    )
}

export default GroupDetails